const init = ({ el }) => {
  // Add js-enabled class for progressive enhancement
  el.classList.add('js-enabled');
  
  // Initialize FAQ functionality
  el.querySelectorAll('[js-faqs-question]').forEach((question) => {
    question.addEventListener('click', () => {
      question.parentElement.classList.toggle(mugo.cssClasses.active);
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-module="faqs"]').forEach((el) => {
    init({ el });
  });
});